import React from 'react'
import I18n from 'i18n'
import { Chart } from 'react-chartjs-2'
import { calcErrorBar, calcAverage } from '../ActivityUtils'
import { chartjsRestHeartRateBorderColor, chartjsRestHeartRateColor } from '../../../../common/Constants'
import { uniq } from 'lodash'

const BoxPlotBar = props => {
  const lowerBar = calcErrorBar(0, props.datasets[props.parameter])
  const upperBar = calcErrorBar(1, props.datasets[props.parameter])
  const averageBar = calcAverage(props.datasets[props.parameter])
  const filteredData = props.rawData.filter(dayDatum => dayDatum.parameter === props.parameter).map(dayDatum => dayDatum.value)

  const data = {
    labels: [props.title],
    datasets: [{
      label: props.label,
      backgroundColor: chartjsRestHeartRateColor,
      borderColor: chartjsRestHeartRateBorderColor,
      borderWidth: 1,
      itemRadius: 0,
      data: [filteredData]
    }]
  }
  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        display: true,
        beginAtZero: false, // draw up to up to 4 standard deviations away from the boxplot
        suggestedMin: averageBar - 4 * (averageBar - lowerBar),
        suggestedMax: averageBar + 4 * (upperBar - averageBar)
      },
      y: {
        display: false
      }
    }
  }

  const notEnoughData = (uniq(filteredData).length < 2)

  return (
    <div className='row'>
      <div className='col s1 horizontal-bar-icon'>
        {props.children}
      </div>
      <div className='col s11 contains-horizontal-boxplot'>
        {notEnoughData && <em className='insufficient-data'>{I18n.t('components.dashboards.steps.summary.not_enough_data')}</em>}
        {!notEnoughData && <div className='horizontal-bar-chart'><Chart type='boxplot' data={data} options={options} redraw /></div>}
      </div>
    </div>
  )
}

export default BoxPlotBar
